import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { getChangeLog } from "store/siteRepo/actionCreator";
import DataTable from "common/desktopDataTable";
import Button from "react-bootstrap/Button";
import CustomTooltip from "common/tooltip";
import { toast } from "react-toastify";
import "./style.scss";

const tdClass = "table-root__body__tr__td table-root__body__tr__td__text";
const renderChangeLogDesktopRows = (currentData) => {
  return currentData.map((row) => (
    <tr key={row.changeLogId} className="table-root__body__tr">
      <td className={tdClass}>
        <CustomTooltip text={row.oldProdName}>{row.oldProdName}</CustomTooltip>
      </td>
      <td className={tdClass}>
        <CustomTooltip text={row.newProdName}>{row.newProdName}</CustomTooltip>
      </td>
      <td className={tdClass}>{row.oldSalesNo}</td>
      <td className={tdClass}>{row.newSalesNo}</td>
      <td className={tdClass}>{row.updatedBy}</td>
      <td className={tdClass}>{new Date(row.createdTimestamp).toLocaleDateString()}</td>
    </tr>
  ));
};

const ChangeLog = () => {
  const dispatch = useDispatch();
  const { siteId } = useParams();
  const [changeLogData, setChangeLogData] = useState([]);

  useEffect(() => {
    dispatch(getChangeLog(siteId))
      .then((res) => setChangeLogData(res))
      .catch((err) => {
        console.error(err);
        toast.error("error while fetching change logs");
      });
  }, []);

  const headers = ["Old Name", "New Name", "Old Sales Number", "New Sales Number", "Updated By", "Updated On"];
  return (
    <div className="container-fluid search-form-container change-log__container">
      <div className="search-form-container__title d-flex justify-content-between align-items-start flex-column flex-md-row align-items-md-center">
        <div className="search-form-container__title--text">Change Log</div>
        <Link to={`/siteRepo/site/${siteId}`}>
          <Button variant="outline-primary" onClick={() => true}>
            Back
          </Button>
        </Link>
      </div>
      <div className="container-fluid search-form-container p-0 border-0">
        <DataTable
          tableHeader={headers.map((name) => ({ name }))}
          tableBody={changeLogData}
          renderDesktopRows={renderChangeLogDesktopRows}
          countTitle="Changes"
          displaySearchFilter={false}
          displaySectionTwo={false}
          isSelectAllChecked={false}
          filteredTableList={changeLogData}
          handleSearchFilter={() => true}
          parentComponent="changeLog"
        />
      </div>
    </div>
  );
};

export default ChangeLog;
